import { useEffect } from 'react';
import { getSocket } from '@/lib/socket';
import { useNotificationStore, type AppNotification } from '@/stores/notificationStore';
import { useAuthStore } from '@/stores/authStore';

export function useNotifications() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { addNotification, notifications, unreadCount, markAsRead, markAllAsRead } =
    useNotificationStore();

  useEffect(() => {
    if (!isAuthenticated) return;

    const socket = getSocket();

    const handleNotification = (notification: AppNotification) => {
      addNotification(notification);
    };

    socket.on('notification', handleNotification);

    return () => {
      socket.off('notification', handleNotification);
    };
  }, [isAuthenticated, addNotification]);

  return {
    notifications,
    unreadCount,
    markAsRead,
    markAllAsRead,
  };
}
